import React from 'react';

const NotFound = () => {
    return (
        <div className='my-5'>
            not Found
        </div>
    );
};

export default NotFound;